"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSettings = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../composite/snackbar/snackbar-types");
const error_utils_1 = require("../../utils/error-utils");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const app_settings_api_1 = require("./app-settings-api");
function useAppSettings(url) {
    const intl = (0, react_intl_1.useIntl)();
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [settings, setSettings] = (0, react_1.useState)(undefined);
    const load = (0, event_callback_hook_1.useEventCallback)(async () => {
        try {
            const response = await (0, app_settings_api_1.fetchSettings)(url).response;
            let settings;
            try {
                const json = await response.json();
                settings = json;
            }
            catch {
                settings = {};
            }
            setLoading(false);
            return settings;
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_APP_SETTINGS_MSG_LOAD_ERROR',
                    defaultMessage: 'Chyba načítaní aplikačních nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    const save = (0, event_callback_hook_1.useEventCallback)(async (settings) => {
        try {
            await (0, app_settings_api_1.updateSettings)(url, settings).none();
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const errorDetail = (0, error_utils_1.getErrorMessage)(err);
                const message = intl.formatMessage({
                    id: 'EAS_APP_SETTINGS_MSG_SAVE_ERROR',
                    defaultMessage: 'Chyba uložení aplikačních nastavení: {detail}',
                }, { detail: errorDetail });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                throw err;
            }
        }
    });
    const update = (0, event_callback_hook_1.useEventCallback)(async (settings) => {
        setSettings(settings);
        await save(settings);
    });
    const init = (0, event_callback_hook_1.useEventCallback)(async () => {
        const settings = await load();
        if (settings !== undefined) {
            setSettings(settings);
        }
    });
    const context = (0, react_1.useMemo)(() => ({
        init,
        update,
        settings: settings !== null && settings !== void 0 ? settings : {},
    }), [init, update, settings]);
    return { context, loading, settings };
}
exports.useAppSettings = useAppSettings;
//# sourceMappingURL=app-settings-hook.js.map